class GenderSwitchFooter extends HTMLElement {
  constructor() {
    super();
    
    this.genderSettings = this.getGenderCookieSettings();
    this.elTriggerMen = this.querySelector('[data-trigger-men]');
    this.elTriggerWomen = this.querySelector('[data-trigger-women]');
    this.elTriggerToggle = this.querySelector('[data-trigger-toggle]');

    switch (Cookies.get(this.genderSettings.cookieName)) {
      case this.genderSettings.cookieValueMen:
        this.triggerToggle('m');
        break;
      case this.genderSettings.cookieValueWomen:
        this.triggerToggle('w');
        break;
      default:
        this.triggerToggle('w');
        break;
    }

    this.elTriggerMen.addEventListener('click', e => {
      this.triggerToggle('m');
      setTimeout(() => {
        location.href = this.genderSettings.cookieUrlMen;
      }, 500);
    });
    this.elTriggerWomen.addEventListener('click', e => {
      this.triggerToggle('w');
      setTimeout(() => {
        location.href = this.genderSettings.cookieUrlWomen;
      }, 500);
    });
    this.elTriggerToggle.addEventListener('click', e => {
      this.triggerToggle();
    });

  }


  getGenderCookieSettings() {
    return JSON.parse(document.querySelector('[data-gender-cookie-settings]').textContent);
  }

  triggerToggle(gender) {

    if (gender) {
      switch (gender) {
        case 'm':
          Cookies.set(this.genderSettings.cookieName, this.genderSettings.cookieValueMen, this.genderSettings.cookieDuration);
          window.gender = this.genderSettings.cookieValueMen;
          window.i18nGender = this.genderSettings.i18nMen;
          this.elTriggerToggle.removeAttribute('data-women-active');
          this.elTriggerToggle.setAttribute('data-men-active', '');
          break;
        case 'w':
          Cookies.set(this.genderSettings.cookieName, this.genderSettings.cookieValueWomen, this.genderSettings.cookieDuration);
          window.gender = this.genderSettings.cookieValueWomen;
          window.i18nGender = this.genderSettings.i18nWomen;
          this.elTriggerToggle.removeAttribute('data-men-active');
          this.elTriggerToggle.setAttribute('data-women-active', '');
          break;
      }
    } else {
      switch (Cookies.get(this.genderSettings.cookieName)) {
        case this.genderSettings.cookieValueMen:
          this.triggerToggle('w');
          setTimeout(() => {
            location.href = this.genderSettings.cookieUrlWomen;
          }, 500);
          break;
        case this.genderSettings.cookieValueWomen:
          this.triggerToggle('m');
          setTimeout(() => {
            location.href = this.genderSettings.cookieUrlMen;
          }, 500);
          break;
      }
    }

  }

}

customElements.define('gender-switch-footer', GenderSwitchFooter);
  
